import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from '../../../../constants/layout/store/filterSlice';


const VendorMasterList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Vendor Master"))
    }, [])
    const [searchTerm, setSearchTerm] = useState("");
    const [vendorListData, setVendorListData] = useState([]);
 const [loading, setLoading] = useState(true);


    const columns = {
        ShopName: { text: "Company Name", align: "start", visible: true },
        Name: { text: "Vendor Name", align: "left", visible: true },
        Email: { text: "Email", width:"150px", align: "start", visible: true },
        Contact_No: { text: "Contact No.", align: "end", visible: true },
        Alternate_Number: { text: "Alternate Contact No.", align: "end", visible: true },
        GSTNumber: { text: "GST. No.", align: "end", visible: false },
        PanNo: { text: "PAN No.", align: "end", visible: false },
        Address: { text: "Address", align: "start", visible: true },
        IsInActive: { text: "Active", align: "center", visible: true },
    };
    useEffect(() => {
        fetchGetVendorMaster();
    }, []);
 const [apiStatus, SetApiStatus] = useState(undefined);
    const fetchGetVendorMaster = async () => {
        try {
            const response = await GetServiceCaller(`${API_URL}vendor-masters`);
            SetApiStatus(response?.status);

            if (response.status === 200) {
                const cleanedData = response?.data?.data;
                setVendorListData(cleanedData);
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Vendor Master. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Vendor Master:", error);
        }
    };

    const handleEdit = (id) => {
   
        navigate(`/vendor-master/edit/${id.ID}`)
        

    }
    const handleAddNewVendor = () => {
        navigate(`/vendor-master/add`)
    }


    return (
        <>
            <div className="container-fluid" id="skill_section">
                <div className="container-fluid" id="skill-table-area">
                    <div className="row">
                        <Dynamic_PR_table
                            data={vendorListData}
                            columns={columns}
                            itemsPerPage={10}
                            isSorting={true}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            isApiStatus={apiStatus}
                            isRequiredStatus={true}
                            isSrNoRequired={true}
                            showIcon1={true}
                            showIcon2={false}
                            isActionRequired={true}
                            isAddNewBtnRequired={true}
                            showIcon3={false}
                            showIcon4={false}
                            showIcon5={false}
                            handleIcon1={handleEdit}
                            handleAddNew={handleAddNewVendor}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i class="bi bi-pencil-square icons"></i>,
                                Icon1Text: " Edit",
                                Icon2: <i class="bi bi-trash-fill icons"></i>,
                                Icon3: <i class="bi bi-eye-fill icons"></i>,
                                Icon4: <i class="bi bi-plus-square icons"></i>,
                                Icon4Text: " Add Sub-Contractor",
                            }}
                        />
                    </div>
                </div>

            </div>
        </>
    )
}

export default VendorMasterList